import _ from "lodash";

const initialState = {
    create: false,
    edit: false,
    modalOpenDP: false,
    modalOpenDPService: false,
    modalOpenDPSource: false,
    value: null,
    options: [
        { key: 1, text: 'Data Provider', value: "DP" },
        { key: 2, text: 'DP Service', value: "DP Service" },
        { key: 3, text: 'DP Source', value: "DP Source" },
    ],
    type: {
        DP: "DP",
        DP_SERVICE: "DP Service",
        DP_SOURCE: "DP Source",
    },
};

const addEditReducer = (state = initialState, action) => {
    switch (action.type) {

        case "CREATE_MODAL": {
            let newState = _.cloneDeep(state);
            newState.create = true;
            if (action.payload === newState.type.DP) {
                newState.modalOpenDP = true;
            } else if (action.payload === newState.type.DP_SERVICE) {
                newState.modalOpenDPService = true;
            }   else if (action.payload === newState.type.DP_SOURCE) {
                newState.modalOpenDPSource = true;
            }
            return newState;
        }

        case "CLOSE_MODAL": {
            let newState = _.cloneDeep(state);
            newState.modalOpenDP = false;
            newState.modalOpenDPService = false;
            newState.modalOpenDPSource = false;
            newState.create = false;
            newState.edit = false;
            return newState;
        }


        default:
            return state;
    }
}

export default addEditReducer;
